import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import ItemDetails from './pages/ItemDetails';
import Menu from './pages/Menu';
import CartPage from './pages/CartPage';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import Contact from './pages/Contact';
import CustomerLogin from './pages/CustomerLogin';
import CustomerProfile from './pages/CustomerProfile';
import CustomerOrders from './pages/CustomerOrders';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import OrdersManagement from './pages/OrdersManagement';
import AdminOrderDetails from './pages/AdminOrderDetails';
import MenuManagement from './pages/MenuManagement';
import AddMenuItem from './pages/AddMenuItem';
import CustomersManagement from './pages/CustomersManagement';
import CouponsManagement from './pages/CouponsManagement';
import ContactRequests from './pages/ContactRequests';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import ReviewsManagement from './pages/ReviewsManagement';
import Settings from './pages/Settings';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/item/:id" element={<ItemDetails />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order-confirmation/:id" element={<OrderConfirmation />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<CustomerLogin />} />
        <Route path="/profile" element={<CustomerProfile />} />
        <Route path="/orders" element={<CustomerOrders />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/orders" element={<OrdersManagement />} />
        <Route path="/admin/orders/:id" element={<AdminOrderDetails />} />
        <Route path="/admin/menu" element={<MenuManagement />} />
        <Route path="/admin/menu/add" element={<AddMenuItem />} />
        <Route path="/admin/customers" element={<CustomersManagement />} />
        <Route path="/admin/coupons" element={<CouponsManagement />} />
        <Route path="/admin/contact-requests" element={<ContactRequests />} />
        <Route path="/admin/reports" element={<AnalyticsDashboard />} />
        <Route path="/admin/reviews" element={<ReviewsManagement />} />
        <Route path="/admin/settings" element={<Settings />} />
      </Routes>
    </Router>
  );
}

export default App;
